// eslint-disable-next-line import/no-anonymous-default-export
export default `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
<g id="Group_6283" data-name="Group 6283" transform="translate(-72 -803)">
  <g id="Group_6006" data-name="Group 6006" transform="translate(72 803)">
    <circle id="Ellipse_357" data-name="Ellipse 357" cx="19" cy="19" r="19" fill="#e9eae9"/>
    <g id="Layer_1" data-name="Layer 1" transform="translate(6 6)">
      <path id="Path_6070" data-name="Path 6070" d="M7.664,10.531l4.867-4.867L17.4,10.533,20.232,7.7,12.531,0l-7.7,7.7,2.832,2.832M0,12.531,2.832,9.7,5.664,12.53,2.832,15.362Zm7.664,2L12.531,19.4,17.4,14.529l2.833,2.83v0l-7.7,7.7-7.7-7.7,0,0,2.836-2.828m11.734-2L22.23,9.7l2.832,2.832L22.23,15.364Z" fill="#0f0f0f"/>
      <path id="Path_6071" data-name="Path 6071" d="M968.937,966.063h0l-2.873-2.874-2.124,2.123h0l-.244.244-.5.5,0,0,0,0,2.871,2.872,2.874-2.874v0l0,0" transform="translate(-953.534 -953.534)" fill="#0f0f0f"/>
    </g>
  </g>
</g>
</svg>`;
